export default {
    category3Code: [
        { required: true, message: '请选择Category3', trigger: 'change' }
    ],
    rmcProduceFarmId: [
        { required: true, message: '请选择Farm', trigger: 'change' }
    ],
    cultiVarName: [
        { required: true, message: '请选择作物名称', trigger: 'change' }
    ],
    useClass: [
        { required: true, message: '请选择用途分类', trigger: 'change' }
    ],
    productName: [
        { required: true, message: '请输入商品名', trigger: 'blur' }
    ],
    effectiveComponents: [
        { required: true, message: '请输入有效成分', trigger: 'blur' }
    ],
    contents: [
        { required: true, message: '请输入含量', trigger: 'blur' }
    ],
    safetyDay: [
        { required: true, message: '请输入安全间隔期/天', trigger: 'blur' }
    ],
    producer: [
        { required: true, message: '请输入生产厂家', trigger: 'blur' }
    ],
    dosageForm: [
        { required: true, message: '请输入剂型', trigger: 'change' }
    ],
    usage: [
        { required: true, message: '请选择使用方法', trigger: 'change' }
    ],
    guideUsage: [
        { required: true, message: '请输入指导用量', trigger: 'blur' }
    ],
    maximum: [
        { required: true, message: '请输入最多使用次数/季', trigger: 'blur' }
    ],
    pesticideNumber: [
        { required: true, message: '请输入农药登记证号', trigger: 'blur' }
    ],
    finiteQuantity: [
        { required: true, message: '请输入GB 2763有限量', trigger: 'blur' }
    ],
    // otherStandard: [
    //     { required: true, message: '请输入其他标准', trigger: 'blur' }
    // ],
    medicineUseStatus: [
        { required: true, message: '请选择药品在用状态', trigger: 'change' }
    ],
    modifyReason: [
        { required: true, message: '请输入修改原因', trigger: 'blur' }
    ],
}